import { TelemetryTimer } from 'core-events/components';
import { getContentClassByContentType, SearchFilterContentTypes } from 'search-gateway-client/components';
import { fetchTypeahead as internalFetchTypeahead } from 'stockblocks-client';
import { TypeaheadData } from 'stockblocks-client/src/typeahead/TypeaheadData';

const fetchTypeahead = async (
    contentType: SearchFilterContentTypes,
    query = '',
    typeaheadEnhancementExperiment = false,
): Promise<TypeaheadData | undefined> => {
    const telemetryTimer = TelemetryTimer.start('search.frontEnd.typeAhead');
    const contentClass = getContentClassByContentType(contentType);
    const mappedContentClass = contentClass === 'image' ? 'images' : contentClass;
    const data = await internalFetchTypeahead(mappedContentClass, encodeURIComponent(query));
    void telemetryTimer.stopAndSend();

    if (typeaheadEnhancementExperiment || data?.keywords?.length) {
        return data;
    }
};

export default fetchTypeahead;
